module.exports = __webpack_public_path__ + "img/link-banner-tw.16f8e151.png";